import { render } from "./collectSingle.vue?vue&type=template&id=7c4f6492&scoped=true"
import script from "./collectSingle.vue?vue&type=script&lang=js"
export * from "./collectSingle.vue?vue&type=script&lang=js"

import "./collectSingle.vue?vue&type=style&index=0&id=7c4f6492&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4f6492"]])

export default __exports__